import './Main.css'

import React from 'react'
import DatePicker from 'react-datepicker'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData, loadChecklistExcel, loadChecklistPDF } from './Model'
import { getReportsFromDay } from '@/common/time'
import { ReportsFromDayNotice } from '@/components/reports/ReportsFromDayNotice'

export const ChecklistReportWizardStep1 = () => {
  const { services, session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()

  // react-datepicker is bundled as CJS; the component may be exposed as `default`.
  const ReactDatePicker = (DatePicker as unknown as { default?: typeof DatePicker }).default ?? DatePicker;

  const loadPDF = () => loadChecklistPDF(services, wizardData, session?.user.lang)
  const loadExcel = () => loadChecklistExcel(services, wizardData, session?.user.lang)

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <>
    <div>
      <h3>{translates.for('report.checklist.wizard.title')}</h3>
      <ReportsFromDayNotice />

      <form className="main-form" onSubmit={(e) => {
        e.preventDefault()
        // updateWizardData(wizardData)
        nextStep()
      }}>

        <div className="form-field">
          <label htmlFor="from-date">{translates.for('report.checklist.wizard.from')}:</label>
          <ReactDatePicker
            id="from-date"
            name="from"
            selected={wizardData.from ? new Date(wizardData.from) : null}
            onChange={(date: Date | null) => {
              if (!date || wizardData.to < date) {
                return
              }
              updateWizardData({
                ...wizardData,
                from: date
              })
            }}
            // showTimeSelect={true}
            timeIntervals={15}
            // timeFormat="HH:mm"
            dateFormat="yyyy-MM-dd"
            minDate={getReportsFromDay() ?? undefined}
            maxDate={wizardData.to || undefined}
            // placeholderText="Select start date and time"
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>

        {/* To Date */}
        <div className="form-field">
          <label htmlFor="to-date">{translates.for('report.checklist.wizard.to')}:</label>
          <ReactDatePicker
            id="to-date"
            name="to"
            selected={wizardData.to ? new Date(wizardData.to) : null}
            onChange={(date: Date | null) => {
              if (!date || wizardData.from > date) {
                return
              }
              updateWizardData({
                ...wizardData,
                to: date
              })
            }}
            // showTimeSelect
            timeIntervals={15}
            // timeFormat="HH:mm"
            dateFormat="yyyy-MM-dd"
            placeholderText=""
            minDate={wizardData.from || undefined}
            className="border rounded p-2"
            portalId="tooltip-wrap"
          />
        </div>

        <div className='right-btns'>
          <button className='btn btn-next' onClick={nextStep}>{translates.for('report.checklist.wizard.next')}</button>
          <button type="button" className='btn btn-next' onClick={loadExcel}>{translates.for('popup.export.excel_export')}</button>
          <button type="button" className='btn btn-next' onClick={loadPDF}>{translates.for('report.checklist.wizard.gen_pdf')}</button>
        </div>
      </form>
    </div>
  </>
}
